/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const GripDotsVerticalSolidV6 = (props) => (
  <Icon {...props} name="Grip Dots Vertical Solid V6">
    <path d="M4 3a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 4 3zm0 5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 4 8zm3 5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 7 13zM9 3a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 9 3zm3 5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 12 8zm-3 5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 9 13z" />
  </Icon>
);

export default GripDotsVerticalSolidV6;
